<template>
  <div class="modal">
    <div class="modal-window bg-light_gray">
      <img src="@/assets/images/btn-close.svg" @click="$emit('closeRingoPass')" class="btn-close">
      <div class="text-center">
        <div>
          シェアサイクルを利用するには、JaM idアカウントおよびRingo Passアプリが必要です。Ringo PassアプリにJaM idアカウントとSuica、クレジットカードの情報を登録するとシェアサイクルを利用できます。
        </div>
        <div class="mt-2">
          ※Ringo PassおよびJaM idはJR東日本が提供するサービスです。
        </div>
        <div class="mt-4">
          <a class="button-primary block ringo-pass-color" @click="$emit('openRingoPass')">
            <span class="block whitespace-nowrap">Ringo Passアプリで<br />シェアサイクルを利用する</span>
          </a>
        </div>
        <div class="mt-4">
          <a @click="howtoRingoPass" class="text-blue-700 underline">Ringo Passとは？</a>
        </div>
        <div class="mt-4">
          <a @click="howtoJaMid" class="text-blue-700 underline">JaMidとは？</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {};
  },
  methods: {
    onRingoPass: function (url) {
      this.$emit('onRingoPass', url)
    },
    howtoRingoPass: function () {
      window.open('https://ringopass.com/')
    },
    howtoJaMid: function () {
      window.open('https://jam-id.jp/')
    }
  }
}
</script>

<style scoped>
.ringo-pass-color {
  background-color: #35b6a1;
  border-color: #35b6a1;
}
</style>
